export default {
    state: {
        type: '',
        idCard: '',
        name: '',
        email: '',
        mobile: '',
        nameEn: '',
        societyCode: '',
        businessDateTo: '',
        corporateName: '',
        address: '',
        registerDate: '',
        registerCapital: '',
        registerUploadToken: ''
    },
    getters: {
        getType: state => state.type,
        getIdCard: state => state.idCard,
        getName: state => state.name,
        getEmail: state => state.email,
        getMobile: state => state.mobile,
        getNameEn: state => state.nameEn,
        getSocietyCode: state => state.societyCode,
        getBusinessDateTo: state => state.businessDateTo,
        getCorporateName: state => state.corporateName,
        getAddress_: state => state.address,
        getRegisterDate: state => state.registerDate,
        getRegisterCapital: state => state.registerCapital,
        getRegisterUploadToken: state => state.registerUploadToken
    },
    mutations: {
        setType(state, val) {
            state.type = val;
        },
        setIdCard(state, val) {
            state.idCard = val;
        },
        setName(state, val) {
            state.name = val;
        },
        setEmail(state, val) {
            state.email = val;
        },
        setMobile(state, val) {
            state.mobile = val;
        },
        setNameEn(state, val) {
            state.nameEn = val;
        },
        setSocietyCode(state, val) {
            state.societyCode = val;
        },
        setBusinessDateTo(state, val) {
            state.businessDateTo = val;
        },
        setCorporateName(state, val) {
            state.corporateName = val;
        },
        setAddress(state, val) {
            state.address = val;
        },
        setRegisterDate(state, val) {
            state.registerDate = val;
        },
        setRegisterCapital(state, val) {
            state.registerCapital = val;
        },
        setRegisterUploadToken(state, val) {
            state.registerUploadToken = val;
        }
    },
    actions: {
        setType_(context, val) {
            context.commit('setType', val);
        },
        setIdCard_(context, val) {
            context.commit('setIdCard', val);
        },
        setName_(context, val) {
            context.commit('setName', val);
        },
        setEmail_(context, val) {
            context.commit('setEmail', val);
        },
        setMobile_(context, val) {
            context.commit('setMobile', val);
        },
        setNameEn_(context, val) {
            context.commit('setNameEn', val);
        },
        setSocietyCode_(context, val) {
            context.commit('setSocietyCode', val);
        },
        setBusinessDateTo_(context, val) {
            context.commit('setBusinessDateTo', val);
        },
        setCorporateName_(context, val) {
            context.commit('setCorporateName', val);
        },
        setAddress_(context, val) {
            context.commit('setAddress', val);
        },
        setRegisterDate_(context, val) {
            context.commit('setRegisterDate', val);
        },
        setRegisterCapital_(context, val) {
            context.commit('setRegisterCapital', val);
        },
        setRegisterUploadToken_(context, val) {
            context.commit('setRegisterUploadToken', val);
        }
    }
};